var map = {
	"./000_intro_part1.first.avif": 300,
	"./000_intro_part1.first.png": 301,
	"./000_intro_part1.first.webp": 302,
	"./000_intro_part1.last.avif": 303,
	"./000_intro_part1.last.png": 304,
	"./000_intro_part1.last.webp": 305,
	"./000_intro_part2.first.avif": 306,
	"./000_intro_part2.first.png": 307,
	"./000_intro_part2.first.webp": 308,
	"./000_intro_part2.last.avif": 309,
	"./000_intro_part2.last.png": 310,
	"./000_intro_part2.last.webp": 311,
	"./de/010_home.first.avif": 312,
	"./de/010_home.first.png": 313,
	"./de/010_home.first.webp": 314,
	"./de/080_finish_bad.first.avif": 315,
	"./de/080_finish_bad.first.png": 316,
	"./de/080_finish_bad.first.webp": 317,
	"./de/080_finish_bad.last.avif": 318,
	"./de/080_finish_bad.last.png": 319,
	"./de/080_finish_bad.last.webp": 320,
	"./de/080_finish_good.first.avif": 321,
	"./de/080_finish_good.first.png": 322,
	"./de/080_finish_good.first.webp": 323,
	"./de/080_finish_good.last.avif": 324,
	"./de/080_finish_good.last.png": 325,
	"./de/080_finish_good.last.webp": 326,
	"./de/080_finish_soso.first.avif": 327,
	"./de/080_finish_soso.first.png": 328,
	"./de/080_finish_soso.first.webp": 329,
	"./de/080_finish_soso.last.avif": 330,
	"./de/080_finish_soso.last.png": 331,
	"./de/080_finish_soso.last.webp": 332,
	"./en/010_home.first.avif": 333,
	"./en/010_home.first.png": 334,
	"./en/010_home.first.webp": 335,
	"./en/080_finish_bad.first.avif": 336,
	"./en/080_finish_bad.first.png": 337,
	"./en/080_finish_bad.first.webp": 338,
	"./en/080_finish_bad.last.avif": 339,
	"./en/080_finish_bad.last.png": 340,
	"./en/080_finish_bad.last.webp": 341,
	"./en/080_finish_good.first.avif": 342,
	"./en/080_finish_good.first.png": 343,
	"./en/080_finish_good.first.webp": 344,
	"./en/080_finish_good.last.avif": 345,
	"./en/080_finish_good.last.png": 346,
	"./en/080_finish_good.last.webp": 347,
	"./en/080_finish_soso.first.avif": 348,
	"./en/080_finish_soso.first.png": 349,
	"./en/080_finish_soso.first.webp": 350,
	"./en/080_finish_soso.last.avif": 351,
	"./en/080_finish_soso.last.png": 352,
	"./en/080_finish_soso.last.webp": 353,
	"./games/020_start.first.avif": 354,
	"./games/020_start.first.png": 355,
	"./games/020_start.first.webp": 356,
	"./games/020_start.last.avif": 357,
	"./games/020_start.last.png": 358,
	"./games/020_start.last.webp": 359,
	"./games/030_corner1.first.avif": 360,
	"./games/030_corner1.first.png": 361,
	"./games/030_corner1.first.webp": 362,
	"./games/030_corner1.last.avif": 363,
	"./games/030_corner1.last.png": 364,
	"./games/030_corner1.last.webp": 365,
	"./games/040_tunnel.first.avif": 366,
	"./games/040_tunnel.first.png": 367,
	"./games/040_tunnel.first.webp": 368,
	"./games/040_tunnel.last.avif": 369,
	"./games/040_tunnel.last.png": 370,
	"./games/040_tunnel.last.webp": 371,
	"./games/050_brake.first.avif": 372,
	"./games/050_brake.first.png": 373,
	"./games/050_brake.first.webp": 374,
	"./games/050_brake.last.avif": 375,
	"./games/050_brake.last.png": 376,
	"./games/050_brake.last.webp": 377,
	"./games/060_corner2.first.avif": 378,
	"./games/060_corner2.first.png": 379,
	"./games/060_corner2.first.webp": 380,
	"./games/060_corner2.last.avif": 381,
	"./games/060_corner2.last.png": 382,
	"./games/060_corner2.last.webp": 383,
	"./games/070_boost.first.avif": 384,
	"./games/070_boost.first.png": 385,
	"./games/070_boost.first.webp": 386,
	"./games/070_boost.last.avif": 387,
	"./games/070_boost.last.png": 388,
	"./games/070_boost.last.webp": 389,
	"./intro_background.png": 390,
	"./mobile/000_intro_part2.first.avif": 44,
	"./mobile/000_intro_part2.first.png": 45,
	"./mobile/000_intro_part2.first.webp": 46,
	"./mobile/000_intro_part2.last.avif": 47,
	"./mobile/000_intro_part2.last.png": 48,
	"./mobile/000_intro_part2.last.webp": 49,
	"./mobile/de/010_home.first.avif": 50,
	"./mobile/de/010_home.first.png": 51,
	"./mobile/de/010_home.first.webp": 52,
	"./mobile/de/080_finish_bad.first.avif": 53,
	"./mobile/de/080_finish_bad.first.png": 54,
	"./mobile/de/080_finish_bad.first.webp": 55,
	"./mobile/de/080_finish_bad.last.avif": 56,
	"./mobile/de/080_finish_bad.last.png": 57,
	"./mobile/de/080_finish_bad.last.webp": 58,
	"./mobile/de/080_finish_good.first.avif": 59,
	"./mobile/de/080_finish_good.first.png": 60,
	"./mobile/de/080_finish_good.first.webp": 61,
	"./mobile/de/080_finish_good.last.avif": 62,
	"./mobile/de/080_finish_good.last.png": 63,
	"./mobile/de/080_finish_good.last.webp": 64,
	"./mobile/de/080_finish_soso.first.avif": 65,
	"./mobile/de/080_finish_soso.first.png": 66,
	"./mobile/de/080_finish_soso.first.webp": 67,
	"./mobile/de/080_finish_soso.last.avif": 68,
	"./mobile/de/080_finish_soso.last.png": 69,
	"./mobile/de/080_finish_soso.last.webp": 70,
	"./mobile/en/010_home.first.avif": 71,
	"./mobile/en/010_home.first.png": 72,
	"./mobile/en/010_home.first.webp": 73,
	"./mobile/en/080_finish_bad.first.avif": 74,
	"./mobile/en/080_finish_bad.first.png": 75,
	"./mobile/en/080_finish_bad.first.webp": 76,
	"./mobile/en/080_finish_bad.last.avif": 77,
	"./mobile/en/080_finish_bad.last.png": 78,
	"./mobile/en/080_finish_bad.last.webp": 79,
	"./mobile/en/080_finish_good.first.avif": 80,
	"./mobile/en/080_finish_good.first.png": 81,
	"./mobile/en/080_finish_good.first.webp": 82,
	"./mobile/en/080_finish_good.last.avif": 83,
	"./mobile/en/080_finish_good.last.png": 84,
	"./mobile/en/080_finish_good.last.webp": 85,
	"./mobile/en/080_finish_soso.first.avif": 86,
	"./mobile/en/080_finish_soso.first.png": 87,
	"./mobile/en/080_finish_soso.first.webp": 88,
	"./mobile/en/080_finish_soso.last.avif": 89,
	"./mobile/en/080_finish_soso.last.png": 90,
	"./mobile/en/080_finish_soso.last.webp": 91,
	"./mobile/games/020_start.first.avif": 92,
	"./mobile/games/020_start.first.png": 93,
	"./mobile/games/020_start.first.webp": 94,
	"./mobile/games/020_start.last.avif": 95,
	"./mobile/games/020_start.last.png": 96,
	"./mobile/games/020_start.last.webp": 97,
	"./mobile/games/030_corner1.first.avif": 98,
	"./mobile/games/030_corner1.first.png": 99,
	"./mobile/games/030_corner1.first.webp": 100,
	"./mobile/games/030_corner1.last.avif": 101,
	"./mobile/games/030_corner1.last.png": 102,
	"./mobile/games/030_corner1.last.webp": 103,
	"./mobile/games/040_tunnel.first.avif": 104,
	"./mobile/games/040_tunnel.first.png": 105,
	"./mobile/games/040_tunnel.first.webp": 106,
	"./mobile/games/040_tunnel.last.avif": 107,
	"./mobile/games/040_tunnel.last.png": 108,
	"./mobile/games/040_tunnel.last.webp": 109,
	"./mobile/games/050_brake.first.avif": 110,
	"./mobile/games/050_brake.first.png": 111,
	"./mobile/games/050_brake.first.webp": 112,
	"./mobile/games/050_brake.last.avif": 113,
	"./mobile/games/050_brake.last.png": 114,
	"./mobile/games/050_brake.last.webp": 115,
	"./mobile/games/060_corner2.first.avif": 116,
	"./mobile/games/060_corner2.first.png": 117,
	"./mobile/games/060_corner2.first.webp": 118,
	"./mobile/games/060_corner2.last.avif": 119,
	"./mobile/games/060_corner2.last.png": 120,
	"./mobile/games/060_corner2.last.webp": 121,
	"./mobile/games/070_boost.first.avif": 122,
	"./mobile/games/070_boost.first.png": 123,
	"./mobile/games/070_boost.first.webp": 124,
	"./mobile/games/070_boost.last.avif": 125,
	"./mobile/games/070_boost.last.png": 126,
	"./mobile/games/070_boost.last.webp": 127,
	"./more/more_info_boost_areas.png": 391,
	"./more/more_info_brake_bad.png": 392,
	"./more/more_info_brake_good.png": 393,
	"./more/more_info_corner1_01.png": 394,
	"./more/more_info_corner2_01.png": 395,
	"./testimonial/de/000_wurz.avif": 396,
	"./testimonial/de/000_wurz.png": 397,
	"./testimonial/de/000_wurz.webp": 398,
	"./testimonial/en/000_wurz.avif": 399,
	"./testimonial/en/000_wurz.png": 400,
	"./testimonial/en/000_wurz.webp": 401,
	"./track.png": 402,
	"./trackinfo/trackinfo_kart.avif": 403,
	"./trackinfo/trackinfo_kart.png": 404,
	"./trackinfo/trackinfo_kart.webp": 405,
	"./trackinfo/trackinfo_overview.avif": 406,
	"./trackinfo/trackinfo_overview.png": 407,
	"./trackinfo/trackinfo_overview.webp": 408,
	"./trackinfo/trackinfo_racingline.avif": 409,
	"./trackinfo/trackinfo_racingline.png": 410,
	"./trackinfo/trackinfo_racingline.webp": 411,
	"./trackinfo/trackinfo_tunnel.avif": 412,
	"./trackinfo/trackinfo_tunnel.png": 413,
	"./trackinfo/trackinfo_tunnel.webp": 414,
	"./tunnel/tunnel_collect.jpg": 40,
	"./tunnel/tunnel_psych.jpg": 41,
	"./tunnel/tunnel_route.jpg": 42,
	"./tunnel/tunnel_slalom.jpg": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 299;